"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStatusSwitcher = void 0;
var react_1 = require("react");
var theme_1 = __importDefault(require("../../../styles/theme"));
var objectUtilities_1 = require("../../../util/objectUtilities");
var StatusSwitcher_static_1 = require("./StatusSwitcher.static");
var StatusSwitcher_style_1 = __importDefault(require("./StatusSwitcher.style"));
function useStatusSwitcher(_a) {
    var _b;
    var isLoading = _a.isLoading, onStatusChange = _a.onStatusChange, options = _a.options, status = _a.status;
    var _c = __read((0, react_1.useState)(null), 2), anchorElement = _c[0], setAnchorElement = _c[1];
    var closePopover = function () { return setAnchorElement(null); };
    var openPopover = function (event) { return setAnchorElement(event.currentTarget); };
    var handleClick = (0, react_1.useCallback)(function (newStatus) {
        if (newStatus !== status) {
            onStatusChange(newStatus);
        }
        closePopover();
    }, [onStatusChange, status]);
    var color = ((_b = options[status]) === null || _b === void 0 ? void 0 : _b.color) || theme_1.default.colors.dark;
    var menuOptions = (0, react_1.useMemo)(function () {
        return (0, objectUtilities_1.filterMap)(options, function (option, statusType) {
            var commonProps = {
                status: statusType,
                handleClick: function () { return handleClick(statusType); },
                isSelected: status === statusType,
            };
            if (!option) {
                return commonProps;
            }
            var isDisabled = option.isDisabled, subText = option.subText, tooltip = option.tooltip, isHidden = option.isHidden;
            if (isHidden) {
                return false;
            }
            return __assign(__assign({}, commonProps), { isDisabled: isDisabled, subText: subText && "- ".concat(subText), tooltip: tooltip });
        });
    }, [handleClick, options, status]);
    return {
        anchorElement: anchorElement,
        buttonTooltip: isLoading ? StatusSwitcher_static_1.localText.updating : undefined,
        classes: (0, StatusSwitcher_style_1.default)({ color: color }),
        closePopover: closePopover,
        openPopover: openPopover,
        menuOptions: menuOptions,
    };
}
exports.useStatusSwitcher = useStatusSwitcher;
